class FreeShippingMeter extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(window.ProvenanceCommerce?.freeShippingThreshold || window.free_shipping_price || 350);
    this.currency = window.ProvenanceCommerce?.currency || window.shop_currency || 'AUD';
    this.progressBar = this.querySelector('[data-shipping-progress]');
    this.progressTrack = this.querySelector('[role="progressbar"]');
    this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
    this.messageElement = this.querySelector('[data-shipping-message]');
    this.refresh = this.refresh.bind(this);

    this.refresh();
    document.addEventListener('cart:refresh', this.refresh);
    document.addEventListener('cart:updated', this.refresh);
    document.addEventListener('cart:update', this.refresh);
    document.addEventListener('change', this.handlePotentialCartChange.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('cart:refresh', this.refresh);
    document.removeEventListener('cart:updated', this.refresh);
    document.removeEventListener('cart:update', this.refresh);
  }

  handlePotentialCartChange(event) {
    if (event.target.closest('cart-items, .cart-item, .previewCartItem, [data-cart-item]')) {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(this.refresh, 450);
    }
  }

  async refresh() {
    try {
      const cartUrl = window.routes?.cart ? `${window.routes.cart}.js` : '/cart.js';
      const response = await fetch(cartUrl, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      const cart = await response.json();
      this.render(cart);
    } catch (error) {
      console.warn('[Provenance] Complimentary delivery meter could not refresh.', error);
    }
  }

  render(cart) {
    const total = Number(cart.total_price || 0) / 100;
    const progress = Math.min(100, Math.max(0, (total / this.threshold) * 100));
    const remaining = Math.max(0, this.threshold - total);

    this.progressBar?.classList.toggle('progress-hidden', total <= 0);
    if (this.progressMeter) this.progressMeter.style.width = `${progress}%`;
    if (this.progressTrack) {
      this.progressTrack.setAttribute('aria-valuenow', String(Math.round(total)));
      this.progressTrack.setAttribute('aria-valuemax', String(this.threshold));
    }

    if (!this.messageElement) return;

    if (total <= 0) {
      this.messageElement.textContent = `Complimentary standard delivery is available on eligible Australian orders of ${this.formatMoney(this.threshold)} or more.`;
    } else if (total >= this.threshold) {
      this.messageElement.textContent = 'You qualify for complimentary standard delivery.';
    } else {
      this.messageElement.textContent = `Add ${this.formatMoney(remaining)} more to qualify for complimentary standard delivery.`;
    }

    this.classList.toggle('is-qualified', total >= this.threshold);
  }

  formatMoney(amount) {
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      return `$${Math.round(amount)}`;
    }
  }
}

if (!customElements.get('free-shipping-component')) {
  customElements.define('free-shipping-component', FreeShippingMeter);
}
